module.exports = (options) => {
  const Utils = require('./Utils');
  const hash = options.hash;
  const key = hash.var;
  let value = hash.value;

  if (options.fn) {
    value = options.fn(this);
  }

  if (!key || key.indexOf('.') !== -1) {
    throw new Error(`Invalid var '${key}'`);
  }

  if (hash && (hash.evaluate === true || hash.evaluate === 'true')) {
    value = Utils.evaluate(value, options);
  }
  Utils.set(key, value, options);
};
